// export const baseurl =
//   window.location.origin === "http://localhost:3000"
//     ? "http://swticherootesting.herokuapp.com"
//     : window.location.origin;
export const baseurl = "/api"